export default __webpack_public_path__ + "static/media/arcgis-urban.248f32b7.png";